exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swipe-card.v-list[data-v-80382bf8]{padding:0}.swipeoutleft[data-v-80382bf8],.swipeoutright[data-v-80382bf8]{width:50px;display:flex;justify-content:center;align-items:center;cursor:pointer}.swipeoutleft .swap__btn[data-v-80382bf8],.swipeoutright .swap__btn[data-v-80382bf8]{margin:0!important;padding:0!important;width:100%!important;height:100%!important;min-width:auto!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./modules/Home/views/src/components/CardNota.vue?vue&type=style&index=0&id=80382bf8&scoped=true&lang=scss&
// module id = 811
// module chunks = 0